/** POST body for /segments/:segment_id/share-links — the Market Sizing
 * config frozen into the segment's share link; posting again overwrites it. */
export interface CreateShareLinkBody {
  /** Days until the link expires; the server's default TTL applies when
   * omitted. */
  expires_in_days?: number;
  config: {
    /** Same shape as SpendCategoriesByModel (MarketSizing/constants.ts). */
    spend_categories_by_model: Record<
      string,
      { ids: string[]; weights: Record<string, number> }
    >;
    /** Same shape as TierSettingsByModel (MarketSizing/constants.ts) — tier
     * names and hidden tiers are per scoring model, like the spend categories
     * above, so a model the prospect switches to shows its own. */
    tier_settings_by_model: Record<
      string,
      { names: Record<string, string>; hidden: string[] }
    >;
    corporate_parent_only: boolean;
    localize_installs: boolean;
    scoring_v2_enabled: boolean;
  };
}

/** A segment's single share link. `token` is null when the URL can no longer
 * be derived — updating the link regenerates it. */
export interface ShareLink {
  id: string;
  token: string | null;
  expires_at: string;
  revoked_at: string | null;
  config: CreateShareLinkBody["config"];
}

export const isShareLinkActive = (link: ShareLink | null): boolean =>
  link !== null &&
  link.revoked_at === null &&
  new Date(link.expires_at).getTime() > Date.now();
